<template>
  <div>
    <!-- <affiche></affiche> -->
    <!-- 顶部 -->
    <div class="header">
      <v-header @search="search"></v-header>
      <v-nav @showlogin="showLogin"></v-nav>
    </div>
    <transition name="router-fade" mode="out-in">
      <!-- <keep-alive> -->
        <router-view @showlogin="showLogin" @showregist="showRegist"></router-view>
      <!-- </keep-alive> -->
    </transition>
    <login-dialog ref="login" @showregist="showRegist"></login-dialog>
    <regist ref="regist"></regist>
    <v-footer></v-footer>
  </div>
</template>

<script>
  import regist from '@/components/regist/regist'
  import loginDialog from '@/components/loginDialog/loginDialog'
  import nav from '@/components/common/nav/nav'
  import affiche from '@/components/common/affiche/affiche'
  import header from '@/components/common/header/header'
  import { userResource } from '@/resource/resource'
  import { mapState, mapMutations } from 'vuex'
  // import { loadFromLocal } from '@/common/js/store'
  import { getCookie, deleteCookie } from '@/common/js/cookies'
  import footer from '@/components/common/footer/footer'
  const ERR_OK = 0

  export default {
    name: 'home',
    data () {
      return {
        searchData: {}
      }
    },
    computed: {
      ...mapState(['logined', 'config_info', 'userInfo', 'noticeList'])
    },
    created () {
      if (getCookie('isLogined') && !this.logined) {
        this.getUserInfo()
      }
    },
    mounted () {
    },
    methods: {
      search(data) {
        this.searchData = data
        if (this.$route.name !== 'goods') {
          this.$router.push({path: '/goods', query: data})
        } else {
          this.$router.replace({path: '/goods', query: data})
        }
        // this.$router.push({path: '/goods', query: data})
      },
      showRegist(str) {
        console.log(str)
        console.log(this.$refs)
        this.$refs.regist.showRegist(true)
      },
      showLogin(state) {
        this.$refs.login.showDialog(state)
      },
      // 自动登录获取用户信息
      getUserInfo () {
        userResource.info().then(response => {
          response = response.body
          if (response.errcode === ERR_OK) {
            this.AUTO_USERINFO(response.data)
          } else {
            deleteCookie('isLogined')
          }
        })
      },
      // 更新vuex状态信息
      ...mapMutations([
        'AUTO_USERINFO',
        'RECORD_USERINFO',
        'NOTICELIST'
      ])
    },
    watch: {
    // 如果路由有变化，会再次执行该方法
    // '$route': 'getOneLottery'
    '$route' (to, from) {
        // 对路由变化作出响应...
        if (to.name !== 'index') {
          this.show = false
        }
      }
    },
    components: {
      'v-nav': nav,
      'v-footer': footer,
      'v-header': header,
      'affiche': affiche,
      loginDialog,
      regist
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus" scoped>
  .header
    background-color #fff
  .router-fade-enter-active, .router-fade-leave-active
    transition: opacity .3s
  .router-fade-enter, .router-fade-leave-active
    opacity: 0
</style>



// WEBPACK FOOTER //
// home.vue?290437fc